import * as React from "react";
import { connect } from "react-redux";
import { Tooltip } from "@mantine/core";
import { IState } from "../../../data/reducers/state";
import { IPersonUpdate } from "../../../types/persons/person";

interface IEmailVerifiedPromptProps {
  person: IPersonUpdate;
}

const EmailVerifiedPrompt: React.FunctionComponent<
  IEmailVerifiedPromptProps
> = (props) => {
  if (!props?.person) return <></>;
  if (props?.person?.emailVerified) return <></>;

  return (
    <Tooltip
      label="You have not verified your email address."
      position="bottom"
      withArrow
    >
      <span
        style={{
          backgroundColor: "var(--color-brand-dark)",
          display: "inline-block",
          width: "10px",
          height: "10px",
          borderRadius: "5px",
          marginLeft: "5px",
          cursor: "pointer",
        }}
      />
    </Tooltip>
  );
};

function mapStateToProps(state: IState, props) {
  return {
    person: state.persons.self && state.persons.map[state.persons.self],
  };
}

export default connect(mapStateToProps)(EmailVerifiedPrompt);
